import {
  Dropzone,
  DropzoneContent,
  DropzoneEmptyState,
  DropzoneProps,
} from "./Dropzone";

export const LimeDropzone = ({
  dropzoneProps,
}: {
  dropzoneProps: DropzoneProps;
}) => {
  return (
    <Dropzone {...dropzoneProps}>
      <DropzoneContent />
      <DropzoneEmptyState />
    </Dropzone>
  );
};
